module.exports = __webpack_public_path__ + "media/images/caregiver/caregiver_avatar_02-46bb78405e7c6f377358843c497cc329.png";